import { render, staticRenderFns } from "./expense-management-items.vue?vue&type=template&id=56541d64&scoped=true&"
import script from "./expense-management-items.vue?vue&type=script&lang=js&"
export * from "./expense-management-items.vue?vue&type=script&lang=js&"
import style0 from "./expense-management-items.vue?vue&type=style&index=0&id=56541d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56541d64",
  null
  
)

export default component.exports